import Modal from './Modal';

/**
 * "Are you sure" with the consequence written out.
 *
 * <p>Three controls on the Content Library needed one and there was none, which is how
 * retiring a chapter ended up being a ghost button that reads like hiding a row. It is
 * not a ghost button's worth of consequence: since the delivery gate started asking
 * whether the chapter is still active, retiring one takes every file in it out of
 * reach, including from the links already in people's hands.
 *
 * <p>So the body is a slot rather than a message prop. A confirmation that says
 * "Are you sure?" has told the reader nothing they did not know when they clicked; the
 * only version worth interrupting someone for names what happens and to whom. The
 * caller writes that sentence, because the caller is the only one who knows it.
 *
 * <p>No window.confirm: it cannot be styled, cannot say this much, and on some
 * browsers offers to suppress itself for the rest of the session — which would quietly
 * remove the check this exists to add.
 */
export default function ConfirmDialog({
  title,
  confirmLabel = 'Confirm',
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
  children,
}) {
  return (
    <Modal
      title={title}
      width={480}
      // Escape and a click outside both cancel, which is the safe direction. Nothing
      // here is confirmed by dismissing it.
      onClose={busy ? () => {} : onCancel}
      footer={
        <>
          <button type="button" className="btn btn-ghost" disabled={busy} onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </>
      }
    >
      {children}
    </Modal>
  );
}
